import React, { useState, useEffect } from 'react';
import { SPARK_URL } from '../apiConfig';

// ============================================
// PassedList — Review profiles you passed on
// ============================================
// Shows declined profiles for up to 14 days.
// User can restore them to discovery or let them expire.
// After 3 total passes on the same person = permanent hide.
// ============================================

export default function PassedList({ onBack }) {
  var [passed, setPassed] = useState([]);
  var [loading, setLoading] = useState(true);

  var token = localStorage.getItem('accessToken');

  useEffect(function() { loadPassed(); }, []);

  async function loadPassed() {
    setLoading(true);
    try {
      var res = await fetch(SPARK_URL + '/discovery/passed', {
        headers: { 'Authorization': 'Bearer ' + token },
      });
      var data = await res.json();
      if (data.success) setPassed(data.data || []);
    } catch (e) { console.error('Load passed error:', e); }
    setLoading(false);
  }

  async function restoreProfile(passedUserId) {
    try {
      var res = await fetch(SPARK_URL + '/discovery/restore/' + passedUserId, {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + token },
      });
      var data = await res.json();
      if (data.success) {
        setPassed(function(prev) { return prev.filter(function(p) { return String(p.passedUserId) !== String(passedUserId); }); });
      } else {
        alert(data.message || 'Could not restore');
      }
    } catch (e) { console.error('Restore error:', e); }
  }

  if (loading) {
    return <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>Loading...</div>;
  }

  return (
    <div style={{ padding: '0 16px 100px' }}>
      <button onClick={onBack} style={{
        background: 'none', border: 'none', color: 'var(--primary)',
        fontSize: 14, fontWeight: 600, cursor: 'pointer', padding: '12px 0',
      }}>← Back to discover</button>

      <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 4px' }}>
        Passed profiles
      </h2>
      <p style={{ fontSize: 13, color: 'var(--text-secondary)', margin: '0 0 16px', lineHeight: 1.5 }}>
        Profiles you passed on in the last 14 days. Changed your mind? Tap restore.
      </p>

      {passed.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--text-muted)' }}>
          <span style={{ fontSize: 36, display: 'block', marginBottom: 8 }}>✨</span>
          <p style={{ fontSize: 14 }}>No passed profiles right now</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {passed.map(function(item) {
            return (
              <div key={item._id} style={{
                display: 'flex', alignItems: 'center', gap: 12,
                background: 'var(--surface)', border: '1px solid var(--border)',
                borderRadius: 14, padding: '12px 14px',
              }}>
                {/* Photo */}
                {item.profile?.photo ? (
                  <img src={item.profile.photo} alt={item.profile.firstName} style={{
                    width: 50, height: 50, borderRadius: '50%', objectFit: 'cover',
                  }} />
                ) : (
                  <div style={{
                    width: 50, height: 50, borderRadius: '50%', background: 'var(--surface-alt)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 20, color: 'var(--text-muted)',
                  }}>👤</div>
                )}

                {/* Info */}
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-primary)' }}>
                    {item.profile?.firstName || 'Unknown'}{item.profile?.age ? ', ' + item.profile.age : ''}
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
                    {item.profile?.city && '📍 ' + item.profile.city + ' · '}
                    {item.daysLeft} day{item.daysLeft !== 1 ? 's' : ''} left
                    {item.passCount > 1 && ' · Passed ' + item.passCount + 'x'}
                  </div>
                </div>

                {/* Restore button */}
                <button onClick={() => restoreProfile(item.passedUserId)} style={{
                  padding: '8px 16px', borderRadius: 10, border: 'none',
                  background: 'var(--primary)', color: '#fff',
                  fontSize: 12, fontWeight: 600, cursor: 'pointer',
                }}>
                  Restore
                </button>
              </div>
            );
          })}
        </div>
      )}

      <p style={{
        fontSize: 11, color: 'var(--text-muted)', textAlign: 'center',
        marginTop: 20, lineHeight: 1.5,
      }}>
        Profiles expire after 14 days. After 3 total passes on the same person, they're permanently hidden.
      </p>
    </div>
  );
}
